import { Route } from 'react-router-dom'
import Noticeboard from 'screens/Noticeboard/Noticeboard'
import ViewNotice from 'screens/Noticeboard/components/ViewNotice'

const INDEX = 'noticeboard'
const VIEW = ':id'

export const noticeboardRoutes = (
  <Route path={INDEX}>
    <Route element={<Noticeboard />} index />
    <Route path={VIEW} element={<ViewNotice />} />
  </Route>
)

export default noticeboardRoutes
